// #287 — the company's map settings, read from the map config every map has already loaded.
// useMapConfig fetches the config; this hook only reads the cached copy and follows its changes.
// It registers no query of its own: a second registration without a fetch function broke every
// refresh of the config (browser run 2026-10-09). It never needs the auth store either, so the
// pages and tests that show the legend stay light. Missing keys, or no config yet, take the defaults.
import { useCallback, useMemo, useSyncExternalStore } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { queryKeys } from '@/config/queryConfig'
import { withDefaults } from '@/lib/mapSettings'
import type { MapConfig, MapSettings } from '@/types'

export function useMapSettings(): MapSettings {
  const qc = useQueryClient()
  const subscribe = useCallback((onChange: () => void) => qc.getQueryCache().subscribe(onChange), [qc])
  const read = useCallback(() => qc.getQueryData<MapConfig>(queryKeys.mapConfig.active('web'))?.map_settings, [qc])
  const partial = useSyncExternalStore(subscribe, read)
  return useMemo(() => withDefaults(partial), [partial])
}
